export const SET_MODAL = 'SET_MODAL';
export const MODAL_CONFIRM = 'MODAL_CONFIRM';
export const MODAL_CANCEL = 'MODAL_CANCEL';


export const setConfirmModalType = (modalType: any) => ({
    type: SET_MODAL,
    modalType
})

export const modalConfirm = () => ({
    type: MODAL_CONFIRM
})

export const modalCancel = () => ({
    type: MODAL_CANCEL
})

const initialState = {
    modalType: null
}

export const modalReducer = (state = initialState, action: any) => {

    switch (action.type) {
        case SET_MODAL:
            const { modalType } = action;
            return { ...state, modalType };
        case MODAL_CONFIRM:
            return { ...initialState, initialState };
        case MODAL_CANCEL:
            return {...initialState, initialState}
        default:
            return state
    }
}